import cn from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';

type Props = {
  title: string;
  padded?: boolean;
  onClick?: () => void;
  button?: {
    text: string;
    icon: IconLookup;
  };
  showButton?: boolean;
};

export default function Title({ title, padded, onClick, showButton, button }: Props) {
  return (
    <button
      className={cn('group', 'flex w-full justify-between items-center', 'text-lg font-semibold mb-3', {
        'cursor-default': !showButton,
      })}
      onClick={onClick}
    >
      <span className={cn({ 'px-4 pt-4': padded, 'group-hover:underline': showButton })}>{title}</span>
      {showButton && button && (
        <span className="flex items-center text-slate-500 group-hover:text-slate-800">
          <span className="text-xs mr-2">{button.text}</span>
          <FontAwesomeIcon icon={button.icon} />
        </span>
      )}
    </button>
  );
}
